const randomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export function rand(min: number, max: number) {
  if (!crypto) return randomNumber(min, max);
  return (min + ((max - min + 1) * crypto.getRandomValues(new Uint32Array(1))[0]) / 2 ** 32) | 0;
}
